// import React, { useEffect, useState } from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import * as Yup from "yup";
// import {
//     Button,
//     Grid,
//     TextField,
//     FormControl,
//     Select,
//     MenuItem,
//     FormHelperText
// } from "@mui/material";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
// import { Country, State, City } from "country-state-city";

// const AddCustomer = () => {
//     const navigate = useNavigate();
//     const [alert, setAlert] = React.useState(false);
//     const [alertContent, setAlertContent] = React.useState("");
//     const [alertType, setAlertType] = React.useState("");

//     const handleAlert = () => setAlert(false);

//     // Country / State / City
//     const [countries] = useState(Country.getAllCountries());
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [selectedCountry, setSelectedCountry] = useState(null);
//     const [selectedState, setSelectedState] = useState(null);

//     const initialValues = {
//         name: "",
//         industry: "",
//         country: "",
//         state: "",
//         city: "",
//         headCount: "",
//         revenue: "",
//         primaryContactNumber: "",
//         primaryContactEmail: ""
//     };

//     const validationSchema = Yup.object().shape({
//         name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
//         industry: Yup.string().required("Industry is required"),
//         country: Yup.string().required("Country is required"),
//         state: Yup.string().required("State is required"),
//         city: Yup.string().required("City is required"),
//         headCount: Yup.number().required("Head count is required").positive("Must be positive"),
//         revenue: Yup.number().required("Revenue is required").positive("Must be positive"),
//         primaryContactNumber: Yup.string().required("Primary contact number is required"),
//         primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
//     });

//     useEffect(() => {
//         if (selectedCountry) {
//             setStates(State.getStatesOfCountry(selectedCountry.isoCode));
//             setCities([]);
//         } else {
//             setStates([]);
//             setCities([]);
//         }
//     }, [selectedCountry]);

//     useEffect(() => {
//         if (selectedState) {
//             setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
//         } else {
//             setCities([]);
//         }
//     }, [selectedState]);

//     const onSubmit = async (values, { setSubmitting }) => {
//         try {
//             const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//             const config = { headers: { Authorization: `Bearer ${token}` } };

//             const payload = {
//                 ...values,
//                 location: `${values.city}, ${values.state}, ${values.country}`,
//                 role: "customer"
//             };

//             const res = await API.post("/api/customer/addCustomer", payload, config);
//             setAlertContent(res?.data?.message || "Customer added successfully");
//             setAlertType("success");
//             setAlert(true);
//             setTimeout(() => navigate("/customers"), 1500);
//         } catch (error) {
//             setAlertContent(error?.response?.data?.message || "Failed to add customer");
//             setAlertType("error");
//             setAlert(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const navigateToPreviousPage = () => navigate(-1);

//     return (
//         <div style={{ marginTop: "20px" }}>
//             <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//                 Back
//             </Button>
//             <div
//                 style={{
//                     border: "1px solid #989898",
//                     borderRadius: "10px",
//                     padding: "15px"
//                 }}
//             >
//                 <div
//                     style={{
//                         fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                         fontSize: "20px",
//                         fontWeight: "500",
//                         letterSpacing: "1",
//                         textAlign: "left"
//                     }}
//                 >
//                     <span>Create Customer</span>
//                 </div>
//                 <div style={{ display: "grid", marginTop: "15px" }}>
//                     <Formik
//                         initialValues={initialValues}
//                         validationSchema={validationSchema}
//                         onSubmit={onSubmit}
//                     >
//                         {(formik) => (
//                             <Form noValidate>
//                                 <Grid container spacing={2}>
//                                     {/* Name */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Customer Name</span>
//                                         <TextField
//                                             name="name"
//                                             fullWidth
//                                             value={formik.values.name}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.name && formik.errors.name && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.name}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Primary Contact Email */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: '16px' }}>Contact Email</span>
//                                         <TextField
//                                             name="primaryContactEmail"
//                                             type="email"
//                                             fullWidth
//                                             value={formik.values.primaryContactEmail}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.primaryContactEmail && formik.errors.primaryContactEmail && (
//                                             <div style={{ color: 'red', marginTop: '4px', fontSize: '14px' }}>
//                                                 {formik.errors.primaryContactEmail}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Primary Contact Number */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: '16px' }}>Contact Number</span>
//                                         <TextField
//                                             name="primaryContactNumber"
//                                             fullWidth
//                                             value={formik.values.primaryContactNumber}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.primaryContactNumber && formik.errors.primaryContactNumber && (
//                                             <div style={{ color: 'red', marginTop: '4px', fontSize: '14px' }}>
//                                                 {formik.errors.primaryContactNumber}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Industry */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Industry</span>
//                                         <TextField
//                                             name="industry"
//                                             fullWidth
//                                             value={formik.values.industry}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.industry && formik.errors.industry && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.industry}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Country */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Country</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.country && formik.errors.country)}
//                                         >
//                                             <Select
//                                                 name="country"
//                                                 value={formik.values.country}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const countryName = e.target.value;
//                                                     formik.setFieldValue("country", countryName);
//                                                     const sel = countries.find((c) => c.name === countryName) || null;
//                                                     setSelectedCountry(sel);
//                                                     setSelectedState(null);
//                                                     formik.setFieldValue("state", "");
//                                                     formik.setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select Country</em>
//                                                 </MenuItem>
//                                                 {countries.map((c) => (
//                                                     <MenuItem key={c.isoCode} value={c.name}>
//                                                         {c.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.country && formik.errors.country}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* State */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>State</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.state && formik.errors.state)}
//                                         >
//                                             <Select
//                                                 name="state"
//                                                 value={formik.values.state}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const stateName = e.target.value;
//                                                     formik.setFieldValue("state", stateName);
//                                                     const sel = states.find((s) => s.name === stateName) || null;
//                                                     setSelectedState(sel);
//                                                     formik.setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select State</em>
//                                                 </MenuItem>
//                                                 {states.map((s) => (
//                                                     <MenuItem key={s.isoCode} value={s.name}>
//                                                         {s.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.state && formik.errors.state}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* City */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>City</span>
//                                         <FormControl
//                                             fullWidth
//                                             size="small"
//                                             error={Boolean(formik.touched.city && formik.errors.city)}
//                                         >
//                                             <Select
//                                                 name="city"
//                                                 value={formik.values.city}
//                                                 displayEmpty
//                                                 onChange={formik.handleChange}
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>Select City</em>
//                                                 </MenuItem>
//                                                 {cities.map((ct) => (
//                                                     <MenuItem key={ct.name} value={ct.name}>
//                                                         {ct.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {formik.touched.city && formik.errors.city}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* Head Count */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Head Count</span>
//                                         <TextField
//                                             name="headCount"
//                                             type="number"
//                                             fullWidth
//                                             value={formik.values.headCount}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.headCount && formik.errors.headCount && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.headCount}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Revenue */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Revenue</span>
//                                         <TextField
//                                             name="revenue"
//                                             type="number"
//                                             fullWidth
//                                             value={formik.values.revenue}
//                                             onChange={formik.handleChange}
//                                             onBlur={formik.handleBlur}
//                                             size="small"
//                                         />
//                                         {formik.touched.revenue && formik.errors.revenue && (
//                                             <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
//                                                 {formik.errors.revenue}
//                                             </div>
//                                         )}
//                                     </Grid>

//                                     {/* Submit */}
//                                     <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 marginTop: "20px"
//                                             }}
//                                         >
//                                             <Button
//                                                 variant="contained"
//                                                 type="submit"
//                                                 disabled={formik.isSubmitting}
//                                                 style={{
//                                                     background: "#2777AA",
//                                                     fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                                                     fontSize: "16px",
//                                                     fontWeight: "500",
//                                                     letterSpacing: "1"
//                                                 }}
//                                             >
//                                                 Submit
//                                             </Button>
//                                         </div>
//                                     </Grid>
//                                 </Grid>
//                                 <Notification
//                                     message={alertContent}
//                                     open={alert}
//                                     severity={alertType}
//                                     onClose={handleAlert}
//                                 />
//                             </Form>
//                         )}
//                     </Formik>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AddCustomer;

// --------------------------------------------------------------------------------------------------------
// import React, { useEffect, useState } from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import * as Yup from "yup";
// import { Button, Grid, TextField, FormControl, Select, MenuItem, FormHelperText } from "@mui/material";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
// import { Country, State, City } from "country-state-city";

// const AddCustomer = () => {
//     const navigate = useNavigate();
//     const [alert, setAlert] = React.useState(false);
//     const [alertContent, setAlertContent] = React.useState("");
//     const [alertType, setAlertType] = React.useState("");

//     const handleAlert = () => setAlert(false);

//     // Country / State / City
//     const [countries] = useState(Country.getAllCountries());
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [selectedCountry, setSelectedCountry] = useState(null);
//     const [selectedState, setSelectedState] = useState(null);

//     // Industry options - label (display) & value (snake_case)
//     const industryOptions = [
//         { label: "IT Services & Consulting", value: "IT_Services_&_Consulting" },
//         { label: "Healthcare", value: "Healthcare" },
//         { label: "Manufacturing", value: "Manufacturing" },
//         { label: "Recruitment & staffing agency", value: "Recruitment_&_staffing_agency" },
//         { label: "IT Product & services", value: "IT_Product_&_services" },
//         { label: "Banking & finance", value: "Banking_&_finance" }
//     ];

//     // Headcount range options - label (display) & value
//     const headCountOptions = [
//         { label: "0-50", value: "0-50" },
//         { label: "50-200", value: "50-200" },
//         { label: "200-500", value: "200-500" },
//         { label: "500-1000", value: "500-1000" },
//         { label: "1000-5000", value: "1000-5000" },
//         { label: "5000-10000", value: "5000-10000" },
//         { label: "10000-100000", value: "10000-100000" }
//     ];

//     const initialValues = {
//         name: "",
//         industry: "",
//         country: "",
//         state: "",
//         city: "",
//         headCount: "",
//         revenue: "",
//         primaryContactNumber: "",
//         primaryContactEmail: ""
//     };

//     const validationSchema = Yup.object().shape({
//         name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
//         industry: Yup.string().required("Industry is required"),
//         country: Yup.string().required("Country is required"),
//         state: Yup.string().required("State is required"),
//         city: Yup.string().required("City is required"),
//         // headCount and revenue are now OPTIONAL
//         headCount: Yup.string().optional(),
//         revenue: Yup.number().optional(),
//         primaryContactNumber: Yup.string().required("Primary contact number is required"),
//         primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
//     });

//     useEffect(() => {
//         if (selectedCountry) {
//             setStates(State.getStatesOfCountry(selectedCountry.isoCode));
//             setCities([]);
//         } else {
//             setStates([]);
//             setCities([]);
//         }
//     }, [selectedCountry]);

//     useEffect(() => {
//         if (selectedState) {
//             setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
//         } else {
//             setCities([]);
//         }
//     }, [selectedState]);

//     const onSubmit = async (values, { setSubmitting }) => {
//         try {
//             const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//             const config = {
//                 headers: { Authorization: `Bearer ${token}` }
//             };
//             const payload = {
//                 ...values,
//                 location: `${values.city}, ${values.state}, ${values.country}`,
//                 role: "customer"
//             };
//             const res = await API.post("/api/customer/addCustomer", payload, config);
//             setAlertContent(res?.data?.message || "Customer added successfully");
//             setAlertType("success");
//             setAlert(true);
//             setTimeout(() => navigate("/customers"), 1500);
//         } catch (error) {
//             setAlertContent(error?.response?.data?.message || "Failed to add customer");
//             setAlertType("error");
//             setAlert(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const navigateToPreviousPage = () => navigate(-1);

//     return (
//         <div style={{ marginTop: "20px" }}>
//             <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//                 Back
//             </Button>
//             <div style={{ border: "1px solid #989898", borderRadius: "10px", padding: "15px" }}>
//                 <div style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "20px", fontWeight: "500", letterSpacing: "1", textAlign: "left" }}>
//                     <span>Create Customer</span>
//                 </div>
//                 <div style={{ display: "grid", marginTop: "15px" }}>
//                     <Formik
//                         initialValues={initialValues}
//                         validationSchema={validationSchema}
//                         onSubmit={onSubmit}
//                     >
//                         {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
//                             <Form noValidate>
//                                 <Grid container spacing={2}>
//                                     {/* Name */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Customer Name <span style={{ color: "red" }}>*</span></span>
//                                         <TextField
//                                             name="name"
//                                             fullWidth
//                                             value={values.name}
//                                             onChange={handleChange}
//                                             onBlur={handleBlur}
//                                             size="small"
//                                             error={touched.name && Boolean(errors.name)}
//                                             helperText={touched.name && errors.name}
//                                         />
//                                     </Grid>

//                                     {/* Industry Dropdown */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Industry <span style={{ color: "red" }}>*</span></span>
//                                         <FormControl fullWidth size="small" error={Boolean(touched.industry && errors.industry)}>
//                                             <Select
//                                                 name="industry"
//                                                 value={values.industry}
//                                                 displayEmpty
//                                                 onChange={(e) => setFieldValue("industry", e.target.value)}
//                                                 onBlur={handleBlur}
//                                             >
//                                                 <MenuItem value="" disabled>Select Industry</MenuItem>
//                                                 {industryOptions.map((industry, index) => (
//                                                     <MenuItem key={index} value={industry.value}>
//                                                         {industry.label}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {touched.industry && errors.industry}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* Country */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
//                                         <FormControl fullWidth size="small" error={Boolean(touched.country && errors.country)}>
//                                             <Select
//                                                 name="country"
//                                                 value={values.country}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const countryName = e.target.value;
//                                                     setFieldValue("country", countryName);
//                                                     const sel = countries.find((c) => c.name === countryName) || null;
//                                                     setSelectedCountry(sel);
//                                                     setSelectedState(null);
//                                                     setFieldValue("state", "");
//                                                     setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="" disabled>Select Country</MenuItem>
//                                                 {countries.map((c) => (
//                                                     <MenuItem key={c.isoCode} value={c.name}>
//                                                         {c.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {touched.country && errors.country}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* State */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>State <span style={{ color: "red" }}>*</span></span>
//                                         <FormControl fullWidth size="small" error={Boolean(touched.state && errors.state)}>
//                                             <Select
//                                                 name="state"
//                                                 value={values.state}
//                                                 displayEmpty
//                                                 onChange={(e) => {
//                                                     const stateName = e.target.value;
//                                                     setFieldValue("state", stateName);
//                                                     const sel = states.find((s) => s.name === stateName) || null;
//                                                     setSelectedState(sel);
//                                                     setFieldValue("city", "");
//                                                 }}
//                                             >
//                                                 <MenuItem value="" disabled>Select State</MenuItem>
//                                                 {states.map((s) => (
//                                                     <MenuItem key={s.isoCode} value={s.name}>
//                                                         {s.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {touched.state && errors.state}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* City */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>City <span style={{ color: "red" }}>*</span></span>
//                                         <FormControl fullWidth size="small" error={Boolean(touched.city && errors.city)}>
//                                             <Select
//                                                 name="city"
//                                                 value={values.city}
//                                                 displayEmpty
//                                                 onChange={handleChange}
//                                             >
//                                                 <MenuItem value="" disabled>Select City</MenuItem>
//                                                 {cities.map((ct) => (
//                                                     <MenuItem key={ct.name} value={ct.name}>
//                                                         {ct.name}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                             <FormHelperText sx={{ color: "red" }}>
//                                                 {touched.city && errors.city}
//                                             </FormHelperText>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* Head Count Dropdown - OPTIONAL */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Head Count</span>
//                                         <FormControl fullWidth size="small">
//                                             <Select
//                                                 name="headCount"
//                                                 value={values.headCount}
//                                                 displayEmpty
//                                                 onChange={handleChange}
//                                                 onBlur={handleBlur}
//                                             >
//                                                 <MenuItem value="" disabled>Select Head Count Range</MenuItem>
//                                                 {headCountOptions.map((range, index) => (
//                                                     <MenuItem key={index} value={range.value}>
//                                                         {range.label}
//                                                     </MenuItem>
//                                                 ))}
//                                             </Select>
//                                         </FormControl>
//                                     </Grid>

//                                     {/* Revenue - OPTIONAL */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Revenue</span>
//                                         <TextField
//                                             name="revenue"
//                                             type="number"
//                                             fullWidth
//                                             value={values.revenue}
//                                             onChange={handleChange}
//                                             onBlur={handleBlur}
//                                             size="small"
//                                         />
//                                     </Grid>

//                                     {/* Primary Contact Email */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Contact Email <span style={{ color: "red" }}>*</span></span>
//                                         <TextField
//                                             name="primaryContactEmail"
//                                             type="email"
//                                             fullWidth
//                                             value={values.primaryContactEmail}
//                                             onChange={handleChange}
//                                             onBlur={handleBlur}
//                                             size="small"
//                                             error={touched.primaryContactEmail && Boolean(errors.primaryContactEmail)}
//                                             helperText={touched.primaryContactEmail && errors.primaryContactEmail}
//                                         />
//                                     </Grid>

//                                     {/* Primary Contact Number */}
//                                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                         <span style={{ fontSize: "16px" }}>Contact Number <span style={{ color: "red" }}>*</span></span>
//                                         <TextField
//                                             name="primaryContactNumber"
//                                             fullWidth
//                                             value={values.primaryContactNumber}
//                                             onChange={handleChange}
//                                             onBlur={handleBlur}
//                                             size="small"
//                                             error={touched.primaryContactNumber && Boolean(errors.primaryContactNumber)}
//                                             helperText={touched.primaryContactNumber && errors.primaryContactNumber}
//                                         />
//                                     </Grid>

//                                     {/* Submit */}
//                                     <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
//                                         <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
//                                             <Button
//                                                 variant="contained"
//                                                 type="submit"
//                                                 disabled={isSubmitting}
//                                                 style={{
//                                                     background: "#2777AA",
//                                                     fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                                                     fontSize: "16px",
//                                                     fontWeight: "500",
//                                                     letterSpacing: "1"
//                                                 }}
//                                             >
//                                                 Submit
//                                             </Button>
//                                         </div>
//                                     </Grid>
//                                 </Grid>
//                                 <Notification
//                                     message={alertContent}
//                                     open={alert}
//                                     severity={alertType}
//                                     onClose={handleAlert}
//                                 />
//                             </Form>
//                         )}
//                     </Formik>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AddCustomer;
// --------------------------------------------------------------------------------------------------------


// --------------------------------------------------------------------------------------------------------

// customer addition with single contact person

// --------------------------------------------------------------------------------------------------------


// import React, { useEffect, useState } from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import * as Yup from "yup";
// import {
//     Button, Grid, TextField, FormControl, Select, MenuItem, FormHelperText,
//     Divider, Typography, Collapse, IconButton, Box
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
// import { Country, State, City } from "country-state-city";

// const AddCustomer = () => {
//     const navigate = useNavigate();
//     const [alert, setAlert] = React.useState(false);
//     const [alertContent, setAlertContent] = React.useState("");
//     const [alertType, setAlertType] = React.useState("");
//     const [showContactSection, setShowContactSection] = useState(false);

//     const handleAlert = () => setAlert(false);

//     // Country / State / City
//     const [countries] = useState(Country.getAllCountries());
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [selectedCountry, setSelectedCountry] = useState(null);
//     const [selectedState, setSelectedState] = useState(null);

//     // Dropdown options (same as before)
//     const industryOptions = [
//         { label: "IT Services & Consulting", value: "IT_Services_&_Consulting" },
//         { label: "Healthcare", value: "Healthcare" },
//         { label: "Manufacturing", value: "Manufacturing" },
//         { label: "Recruitment & staffing agency", value: "Recruitment_&_staffing_agency" },
//         { label: "IT Product & services", value: "IT_Product_&_services" },
//         { label: "Banking & finance", value: "Banking_&_finance" }
//     ];

//     const headCountOptions = [
//         { label: "0-50", value: "0-50" },
//         { label: "50-200", value: "50-200" },
//         { label: "200-500", value: "200-500" },
//         { label: "500-1000", value: "500-1000" },
//         { label: "1000-5000", value: "1000-5000" },
//         { label: "5000-10000", value: "5000-10000" },
//         { label: "10000-100000", value: "10000-100000" }
//     ];

//     const initialValues = {
//         // Customer fields
//         name: "",
//         industry: "",
//         country: "",
//         state: "",
//         city: "",
//         headCount: "",
//         revenue: "",
//         primaryContactNumber: "",
//         primaryContactEmail: "",
//         // Contact person fields
//         contactName: "",
//         contactEmail: "",
//         contactPhone: ""
//     };

//     const validationSchema = Yup.object().shape({
//         // Customer required fields
//         name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
//         industry: Yup.string().required("Industry is required"),
//         country: Yup.string().required("Country is required"),
//         state: Yup.string().required("State is required"),
//         city: Yup.string().required("City is required"),
//         primaryContactNumber: Yup.string().required("Primary contact number is required"),
//         primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
//         // Optional fields
//         headCount: Yup.string().optional(),
//         revenue: Yup.number().optional(),
//         // Contact person (optional but validated if filled)
//         contactName: Yup.string().when('contactEmail', {
//             is: (contactEmail) => contactEmail?.length > 0,
//             then: (schema) => schema.required("Contact name is required").min(2),
//             otherwise: (schema) => schema.optional()
//         }),
//         contactEmail: Yup.string().email("Invalid email format").optional(),
//         contactPhone: Yup.string().when('contactEmail', {
//             is: (contactEmail) => contactEmail?.length > 0,
//             then: (schema) => schema.required("Contact phone is required").min(10, "Minimum 10 digits"),
//             otherwise: (schema) => schema.optional()
//         })
//     });

//     // Country/State/City handlers (same as before)
//     useEffect(() => {
//         if (selectedCountry) {
//             setStates(State.getStatesOfCountry(selectedCountry.isoCode));
//             setCities([]);
//         } else {
//             setStates([]);
//             setCities([]);
//         }
//     }, [selectedCountry]);

//     useEffect(() => {
//         if (selectedState) {
//             setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
//         } else {
//             setCities([]);
//         }
//     }, [selectedState]);

//     const onSubmit = async (values, { setSubmitting }) => {
//         try {
//             const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//             const config = { headers: { Authorization: `Bearer ${token}` } };

//             // Single API payload - customer + contact person
//             const payload = {
//                 // Customer data
//                 name: values.name,
//                 industry: values.industry,
//                 location: `${values.city}, ${values.state}, ${values.country}`,
//                 head_count: values.headCount,
//                 revenue: values.revenue,
//                 primary_contact_number: values.primaryContactNumber,
//                 primary_contact_email: values.primaryContactEmail,
//                 role: "customer",
//                 // Contact person data (optional)
//                 ...(values.contactEmail && {
//                     contact_persons: [{
//                         name: values.contactName,
//                         email: values.contactEmail,
//                         phone: values.contactPhone
//                     }]
//                 })
//             };

//             // Single API call
//             const res = await API.post("/api/customer/addCustomerWithContact", payload, config);

//             setAlertContent(res?.data?.message || "Customer and contact person added successfully!");
//             setAlertType("success");
//             setAlert(true);
//             setTimeout(() => navigate("/customers"), 1500);
//         } catch (error) {
//             setAlertContent(error?.response?.data?.message || "Failed to add customer");
//             setAlertType("error");
//             setAlert(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const navigateToPreviousPage = () => navigate(-1);

//     return (
//         <div style={{ marginTop: "20px" }}>
//             <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//                 Back
//             </Button>
//             <div style={{ border: "1px solid #989898", borderRadius: "10px", padding: "15px" }}>
//                 <div style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "20px", fontWeight: "500", letterSpacing: "1", textAlign: "left" }}>
//                     <span>Create Customer</span>
//                 </div>

//                 <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
//                     {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
//                         <Form noValidate>
//                             <Grid container spacing={2}>
//                                 {/* CUSTOMER FIELDS - ROW 1 */}
//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Customer Name <span style={{ color: "red" }}>*</span></span>
//                                     <TextField name="name" fullWidth value={values.name} onChange={handleChange} onBlur={handleBlur} size="small"
//                                         error={touched.name && Boolean(errors.name)} helperText={touched.name && errors.name} />
//                                 </Grid>

//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Industry <span style={{ color: "red" }}>*</span></span>
//                                     <FormControl fullWidth size="small" error={Boolean(touched.industry && errors.industry)}>
//                                         <Select name="industry" value={values.industry} displayEmpty onChange={(e) => setFieldValue("industry", e.target.value)} onBlur={handleBlur}>
//                                             <MenuItem value="" disabled>Select Industry</MenuItem>
//                                             {industryOptions.map((industry, index) => (
//                                                 <MenuItem key={index} value={industry.value}>{industry.label}</MenuItem>
//                                             ))}
//                                         </Select>
//                                         <FormHelperText sx={{ color: "red" }}>{touched.industry && errors.industry}</FormHelperText>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Country/State/City - 3 fields */}
//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
//                                     <FormControl fullWidth size="small" error={Boolean(touched.country && errors.country)}>
//                                         <Select name="country" value={values.country} displayEmpty
//                                             onChange={(e) => {
//                                                 const countryName = e.target.value;
//                                                 setFieldValue("country", countryName);
//                                                 const sel = countries.find((c) => c.name === countryName) || null;
//                                                 setSelectedCountry(sel);
//                                                 setSelectedState(null);
//                                                 setFieldValue("state", ""); setFieldValue("city", "");
//                                             }}
//                                         >
//                                             <MenuItem value="" disabled>Select Country</MenuItem>
//                                             {countries.map((c) => <MenuItem key={c.isoCode} value={c.name}>{c.name}</MenuItem>)}
//                                         </Select>
//                                         <FormHelperText sx={{ color: "red" }}>{touched.country && errors.country}</FormHelperText>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Continue with State, City, Headcount, Revenue, Primary contacts... */}

//                                 {/* CONTACT PERSON SECTION - COLLAPSIBLE */}
//                                 <Grid item xl={12}>
//                                     <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", mb: 1 }} onClick={() => setShowContactSection(!showContactSection)}>
//                                         <Typography variant="h6" sx={{ flexGrow: 1 }}>Add Contact Person (Optional)</Typography>
//                                         <IconButton size="small">
//                                             {showContactSection ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                                         </IconButton>
//                                     </Box>

//                                     <Collapse in={showContactSection}>
//                                         <Divider sx={{ mb: 2 }} />
//                                         <Grid container spacing={2}>
//                                             <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                 <span style={{ fontSize: "16px" }}>Contact Name</span>
//                                                 <TextField name="contactName" fullWidth value={values.contactName} onChange={handleChange} onBlur={handleBlur}
//                                                     size="small" error={touched.contactName && Boolean(errors.contactName)} helperText={touched.contactName && errors.contactName} />
//                                             </Grid>
//                                             <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                 <span style={{ fontSize: "16px" }}>Contact Email</span>
//                                                 <TextField name="contactEmail" type="email" fullWidth value={values.contactEmail} onChange={handleChange} onBlur={handleBlur}
//                                                     size="small" error={touched.contactEmail && Boolean(errors.contactEmail)} helperText={touched.contactEmail && errors.contactEmail} />
//                                             </Grid>
//                                             <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                 <span style={{ fontSize: "16px" }}>Contact Phone</span>
//                                                 <TextField name="contactPhone" fullWidth value={values.contactPhone} onChange={handleChange} onBlur={handleBlur}
//                                                     size="small" error={touched.contactPhone && Boolean(errors.contactPhone)} helperText={touched.contactPhone && errors.contactPhone} />
//                                             </Grid>
//                                         </Grid>
//                                     </Collapse>
//                                 </Grid>

//                                 {/* Submit */}
//                                 <Grid item xl={12}>
//                                     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
//                                         <Button variant="contained" type="submit" disabled={isSubmitting}
//                                             style={{ background: "#2777AA", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "16px", fontWeight: "500", letterSpacing: "1" }}>
//                                             {showContactSection ? "Save Customer + Contact" : "Save Customer"}
//                                         </Button>
//                                     </div>
//                                 </Grid>
//                             </Grid>

//                             <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
//                         </Form>
//                     )}
//                 </Formik>
//             </div>
//         </div>
//     );
// };

// export default AddCustomer;

// --------------------------------------------------------------------------------------------------------



// --------------------------------------------------------------------------------------------------------

// customer addition with multiple contact person

// --------------------------------------------------------------------------------------------------------

// import React, { useEffect, useState } from "react";
// import { Formik, Form, FieldArray } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import * as Yup from "yup";
// import {
//     Button, Grid, TextField, FormControl, Select, MenuItem, FormHelperText,
//     Divider, Typography, Collapse, IconButton, Box, IconButton as MuiIconButton
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";
// import { Country, State, City } from "country-state-city";

// const AddCustomer = () => {
//     const navigate = useNavigate();
//     const [alert, setAlert] = React.useState(false);
//     const [alertContent, setAlertContent] = React.useState("");
//     const [alertType, setAlertType] = React.useState("");
//     const [showContactSection, setShowContactSection] = useState(false);

//     const handleAlert = () => setAlert(false);

//     // Country / State / City
//     const [countries] = useState(Country.getAllCountries());
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [selectedCountry, setSelectedCountry] = useState(null);
//     const [selectedState, setSelectedState] = useState(null);

//     // Dropdown options
//     const industryOptions = [
//         { label: "IT Services & Consulting", value: "IT_Services_&_Consulting" },
//         { label: "Healthcare", value: "Healthcare" },
//         { label: "Manufacturing", value: "Manufacturing" },
//         { label: "Recruitment & staffing agency", value: "Recruitment_&_staffing_agency" },
//         { label: "IT Product & services", value: "IT_Product_&_services" },
//         { label: "Banking & finance", value: "Banking_&_finance" }
//     ];

//     const headCountOptions = [
//         { label: "0-50", value: "0-50" },
//         { label: "50-200", value: "50-200" },
//         { label: "200-500", value: "200-500" },
//         { label: "500-1000", value: "500-1000" },
//         { label: "1000-5000", value: "1000-5000" },
//         { label: "5000-10000", value: "5000-10000" },
//         { label: "10000-100000", value: "10000-100000" }
//     ];

//     const initialValues = {
//         // Customer fields
//         name: "",
//         industry: "",
//         country: "",
//         state: "",
//         city: "",
//         headCount: "",
//         revenue: "",
//         primaryContactNumber: "",
//         primaryContactEmail: "",
//         // Multiple contact persons
//         contactPersons: [
//             {
//                 name: "",
//                 email: "",
//                 phone: ""
//             }
//         ]
//     };

//     const validationSchema = Yup.object().shape({
//         name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
//         industry: Yup.string().required("Industry is required"),
//         country: Yup.string().required("Country is required"),
//         state: Yup.string().required("State is required"),
//         city: Yup.string().required("City is required"),
//         primaryContactNumber: Yup.string().required("Primary contact number is required"),
//         primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
//         headCount: Yup.string().optional(),
//         revenue: Yup.number().optional(),
//         contactPersons: Yup.array().of(
//             Yup.object().shape({
//                 name: Yup.string().when('email', {
//                     is: (email) => email?.length > 0,
//                     then: (schema) => schema.required("Contact name is required").min(2),
//                     otherwise: (schema) => schema.optional()
//                 }),
//                 email: Yup.string().email("Invalid email format").optional(),
//                 phone: Yup.string().when('email', {
//                     is: (email) => email?.length > 0,
//                     then: (schema) => schema.required("Contact phone is required").min(10, "Minimum 10 digits"),
//                     otherwise: (schema) => schema.optional()
//                 })
//             })
//         )
//     });

//     useEffect(() => {
//         if (selectedCountry) {
//             setStates(State.getStatesOfCountry(selectedCountry.isoCode));
//             setCities([]);
//         } else {
//             setStates([]);
//             setCities([]);
//         }
//     }, [selectedCountry]);

//     useEffect(() => {
//         if (selectedState) {
//             setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
//         } else {
//             setCities([]);
//         }
//     }, [selectedState]);

//     const onSubmit = async (values, { setSubmitting }) => {
//         try {
//             const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//             const config = { headers: { Authorization: `Bearer ${token}` } };

//             // Filter out empty contact persons
//             const validContactPersons = values.contactPersons.filter(person =>
//                 person.email?.trim() || person.name?.trim() || person.phone?.trim()
//             );

//             const payload = {
//                 // Customer data
//                 name: values.name,
//                 industry: values.industry,
//                 location: `${values.city}, ${values.state}, ${values.country}`,
//                 head_count: values.headCount,
//                 revenue: values.revenue,
//                 primary_contact_number: values.primaryContactNumber,
//                 primary_contact_email: values.primaryContactEmail,
//                 role: "customer",
//                 // Multiple contact persons (only valid ones)
//                 ...(validContactPersons.length > 0 && {
//                     contact_persons: validContactPersons
//                 })
//             };

//             const res = await API.post("/api/customer/addCustomerWithContact", payload, config);

//             setAlertContent(res?.data?.message || `Customer and ${validContactPersons.length} contact person(s) added successfully!`);
//             setAlertType("success");
//             setAlert(true);
//             setTimeout(() => navigate("/customers"), 1500);
//         } catch (error) {
//             setAlertContent(error?.response?.data?.message || "Failed to add customer");
//             setAlertType("error");
//             setAlert(true);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const navigateToPreviousPage = () => navigate(-1);

//     return (
//         <div style={{ marginTop: "20px" }}>
//             <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//                 Back
//             </Button>
//             <div style={{ border: "1px solid #989898", borderRadius: "10px", padding: "15px" }}>
//                 <div style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "20px", fontWeight: "500", letterSpacing: "1", textAlign: "left" }}>
//                     <span>Create Customer</span>
//                 </div>

//                 <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
//                     {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
//                         <Form noValidate>
//                             <Grid container spacing={2}>
//                                 {/* CUSTOMER FIELDS */}
//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Customer Name <span style={{ color: "red" }}>*</span></span>
//                                     <TextField name="name" fullWidth value={values.name} onChange={handleChange} onBlur={handleBlur} size="small"
//                                         error={touched.name && Boolean(errors.name)} helperText={touched.name && errors.name} />
//                                 </Grid>

//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Industry <span style={{ color: "red" }}>*</span></span>
//                                     <FormControl fullWidth size="small" error={Boolean(touched.industry && errors.industry)}>
//                                         <Select name="industry" value={values.industry} displayEmpty onChange={(e) => setFieldValue("industry", e.target.value)} onBlur={handleBlur}>
//                                             <MenuItem value="" disabled>Select Industry</MenuItem>
//                                             {industryOptions.map((industry, index) => (
//                                                 <MenuItem key={index} value={industry.value}>{industry.label}</MenuItem>
//                                             ))}
//                                         </Select>
//                                         <FormHelperText sx={{ color: "red" }}>{touched.industry && errors.industry}</FormHelperText>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Country/State/City (same as before - abbreviated for space) */}
//                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                     <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
//                                     <FormControl fullWidth size="small" error={Boolean(touched.country && errors.country)}>
//                                         <Select name="country" value={values.country} displayEmpty
//                                             onChange={(e) => {
//                                                 const countryName = e.target.value;
//                                                 setFieldValue("country", countryName);
//                                                 const sel = countries.find((c) => c.name === countryName) || null;
//                                                 setSelectedCountry(sel);
//                                                 setSelectedState(null);
//                                                 setFieldValue("state", ""); setFieldValue("city", "");
//                                             }}
//                                         >
//                                             <MenuItem value="" disabled>Select Country</MenuItem>
//                                             {countries.map((c) => <MenuItem key={c.isoCode} value={c.name}>{c.name}</MenuItem>)}
//                                         </Select>
//                                         <FormHelperText sx={{ color: "red" }}>{touched.country && errors.country}</FormHelperText>
//                                     </FormControl>
//                                 </Grid>

//                                 {/* Add other customer fields: State, City, Headcount, Revenue, Primary contacts... */}

//                                 {/* MULTIPLE CONTACT PERSONS SECTION */}
//                                 <Grid item xl={12}>
//                                     <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", mb: 1 }} onClick={() => setShowContactSection(!showContactSection)}>
//                                         <Typography variant="h6" sx={{ flexGrow: 1 }}>Add Contact Persons</Typography>
//                                         <IconButton size="small">
//                                             {showContactSection ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                                         </IconButton>
//                                     </Box>

//                                     <Collapse in={showContactSection}>
//                                         <Divider sx={{ mb: 2 }} />
//                                         <FieldArray name="contactPersons">
//                                             {({ push, remove }) => (
//                                                 <div>
//                                                     {values.contactPersons.map((contact, index) => (
//                                                         <Box key={index} sx={{ mb: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
//                                                             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                                                                 <Typography variant="subtitle1">Contact Person {index + 1}</Typography>
//                                                                 {values.contactPersons.length > 1 && (
//                                                                     <MuiIconButton size="small" onClick={() => remove(index)} color="error">
//                                                                         <DeleteOutlineIcon />
//                                                                     </MuiIconButton>
//                                                                 )}
//                                                             </Box>

//                                                             <Grid container spacing={2}>
//                                                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                                     <span style={{ fontSize: "16px" }}>Name</span>
//                                                                     <TextField
//                                                                         name={`contactPersons.${index}.name`}
//                                                                         fullWidth
//                                                                         value={contact.name}
//                                                                         onChange={handleChange}
//                                                                         onBlur={handleBlur}
//                                                                         size="small"
//                                                                         error={touched.contactPersons?.[index]?.name && Boolean(errors.contactPersons?.[index]?.name)}
//                                                                         helperText={touched.contactPersons?.[index]?.name && errors.contactPersons?.[index]?.name}
//                                                                     />
//                                                                 </Grid>

//                                                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                                     <span style={{ fontSize: "16px" }}>Email</span>
//                                                                     <TextField
//                                                                         name={`contactPersons.${index}.email`}
//                                                                         type="email"
//                                                                         fullWidth
//                                                                         value={contact.email}
//                                                                         onChange={handleChange}
//                                                                         onBlur={handleBlur}
//                                                                         size="small"
//                                                                         error={touched.contactPersons?.[index]?.email && Boolean(errors.contactPersons?.[index]?.email)}
//                                                                         helperText={touched.contactPersons?.[index]?.email && errors.contactPersons?.[index]?.email}
//                                                                     />
//                                                                 </Grid>

//                                                                 <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                                                                     <span style={{ fontSize: "16px" }}>Phone</span>
//                                                                     <TextField
//                                                                         name={`contactPersons.${index}.phone`}
//                                                                         fullWidth
//                                                                         value={contact.phone}
//                                                                         onChange={handleChange}
//                                                                         onBlur={handleBlur}
//                                                                         size="small"
//                                                                         error={touched.contactPersons?.[index]?.phone && Boolean(errors.contactPersons?.[index]?.phone)}
//                                                                         helperText={touched.contactPersons?.[index]?.phone && errors.contactPersons?.[index]?.phone}
//                                                                     />
//                                                                 </Grid>
//                                                             </Grid>
//                                                         </Box>
//                                                     ))}

//                                                     <Button
//                                                         type="button"
//                                                         startIcon={<AddCircleOutlineIcon />}
//                                                         onClick={() => push({ name: "", email: "", phone: "" })}
//                                                         sx={{ mt: 1 }}
//                                                     >
//                                                         Add Another Contact Person
//                                                     </Button>
//                                                 </div>
//                                             )}
//                                         </FieldArray>
//                                     </Collapse>
//                                 </Grid>

//                                 {/* Submit */}
//                                 <Grid item xl={12}>
//                                     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
//                                         <Button variant="contained" type="submit" disabled={isSubmitting}
//                                             style={{ background: "#2777AA", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "16px", fontWeight: "500", letterSpacing: "1" }}>
//                                             Submit
//                                         </Button>
//                                     </div>
//                                 </Grid>
//                             </Grid>

//                             <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
//                         </Form>
//                     )}
//                 </Formik>
//             </div>
//         </div>
//     );
// };

// export default AddCustomer;


import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import {
    Button, Grid, TextField, FormControl, Select, MenuItem, FormHelperText,
    Divider, Typography, Collapse, IconButton, Box
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Notification } from "../../utils/Notification";
import API from "../../utils/Axios.utils";
import { Country, State, City } from "country-state-city";

const AddCustomer = () => {
    const navigate = useNavigate();
    const [alert, setAlert] = React.useState(false);
    const [alertContent, setAlertContent] = React.useState("");
    const [alertType, setAlertType] = React.useState("");
    const [showContactSection, setShowContactSection] = useState(true);

    const handleAlert = () => setAlert(false);

    // Country / State / City
    const [countries] = useState(Country.getAllCountries());
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);

    // Dropdown options
    const industryOptions = [
        { label: "IT Services & Consulting", value: "IT_Services_&_Consulting" },
        { label: "Healthcare", value: "Healthcare" },
        { label: "Manufacturing", value: "Manufacturing" },
        { label: "Recruitment & staffing agency", value: "Recruitment_&_staffing_agency" },
        { label: "IT Product & services", value: "IT_Product_&_services" },
        { label: "Banking & finance", value: "Banking_&_finance" }
    ];

    const headCountOptions = [
        { label: "0-50", value: "0-50" },
        { label: "50-200", value: "50-200" },
        { label: "200-500", value: "200-500" },
        { label: "500-1000", value: "500-1000" },
        { label: "1000-5000", value: "1000-5000" },
        { label: "5000-10000", value: "5000-10000" },
        { label: "10000-100000", value: "10000-100000" }
    ];

    const initialValues = {
        name: "",
        industry: "",
        country: "",
        state: "",
        city: "",
        headCount: "",
        revenue: "",
        primaryContactNumber: "",
        primaryContactEmail: "",
        contactPersons: [
            {
                name: "",
                email: "",
                phone: ""
            }
        ]
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Customer name is required").min(2, "Minimum 2 characters"),
        industry: Yup.string().required("Industry is required"),
        country: Yup.string().required("Country is required"),
        state: Yup.string().required("State is required"),
        city: Yup.string().required("City is required"),
        primaryContactNumber: Yup.string().required("Primary contact number is required"),
        primaryContactEmail: Yup.string().required("Primary contact email is required").email("Invalid email format"),
        headCount: Yup.string().optional(),
        revenue: Yup.number().optional(),
        contactPersons: Yup.array()
            .min(1, "At least one contact person is required")
            .of(
                Yup.object().shape({
                    name: Yup.string().required("Contact name is required").min(2, "Minimum 2 characters"),
                    email: Yup.string().required("Contact email is required").email("Invalid email format"),
                    phone: Yup.string().required("Contact phone is required").min(10, "Minimum 10 digits")
                })
            )
    });

    useEffect(() => {
        if (selectedCountry) {
            setStates(State.getStatesOfCountry(selectedCountry.isoCode));
            setCities([]);
        } else {
            setStates([]);
            setCities([]);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            setCities(City.getCitiesOfState(selectedState.countryCode, selectedState.isoCode));
        } else {
            setCities([]);
        }
    }, [selectedState]);

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const validContactPersons = values.contactPersons.filter(person =>
                (person.name && person.name.trim() !== "") ||
                (person.email && person.email.trim() !== "") ||
                (person.phone && person.phone.trim() !== "")
            );

            const payload = {
                name: values.name,
                industry: values.industry,
                location: `${values.city}, ${values.state}, ${values.country}`,
                head_count: values.headCount,
                revenue: values.revenue,
                primary_contact_number: values.primaryContactNumber,
                primary_contact_email: values.primaryContactEmail,
                role: "customer",
                contact_persons: validContactPersons
            };

            const res = await API.post("/api/customer/addCustomesContact", payload, config);

            setAlertContent(res?.data?.message || `Customer and ${validContactPersons.length} contact person(s) added successfully!`);
            setAlertType("success");
            setAlert(true);
            setTimeout(() => navigate("/customers"), 1500);
        } catch (error) {
            setAlertContent(error?.response?.data?.message || "Failed to add customer");
            setAlertType("error");
            setAlert(true);
        } finally {
            setSubmitting(false);
        }
    };

    const navigateToPreviousPage = () => navigate(-1);

    return (
        <div style={{ marginTop: "20px" }}>
            <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
                Back
            </Button>
            <div style={{ border: "1px solid #989898", borderRadius: "10px", padding: "15px" }}>
                <div style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "20px", fontWeight: "500", letterSpacing: "1", textAlign: "left" }}>
                    <span>Create Customer</span>
                </div>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
                        <Form noValidate>
                            <Grid container spacing={2}>
                                {/* CUSTOMER FIELDS */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Customer Name <span style={{ color: "red" }}>*</span></span>
                                    <TextField name="name" fullWidth value={values.name} onChange={handleChange} onBlur={handleBlur} size="small"
                                        error={touched.name && Boolean(errors.name)} helperText={touched.name && errors.name} />
                                </Grid>

                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Industry <span style={{ color: "red" }}>*</span></span>
                                    <FormControl fullWidth size="small" error={Boolean(touched.industry && errors.industry)}>
                                        <Select name="industry" value={values.industry} displayEmpty onChange={(e) => setFieldValue("industry", e.target.value)} onBlur={handleBlur}>
                                            <MenuItem value="" disabled>Select Industry</MenuItem>
                                            {industryOptions.map((industry, index) => (
                                                <MenuItem key={index} value={industry.value}>{industry.label}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>{touched.industry && errors.industry}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* Country */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Country <span style={{ color: "red" }}>*</span></span>
                                    <FormControl fullWidth size="small" error={Boolean(touched.country && errors.country)}>
                                        <Select name="country" value={values.country} displayEmpty
                                            onChange={(e) => {
                                                const countryName = e.target.value;
                                                setFieldValue("country", countryName);
                                                const sel = countries.find((c) => c.name === countryName) || null;
                                                setSelectedCountry(sel);
                                                setSelectedState(null);
                                                setFieldValue("state", "");
                                                setFieldValue("city", "");
                                            }}
                                        >
                                            <MenuItem value="" disabled>Select Country</MenuItem>
                                            {countries.map((c) => (
                                                <MenuItem key={c.isoCode} value={c.name}>{c.name}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>{touched.country && errors.country}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* State */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>State <span style={{ color: "red" }}>*</span></span>
                                    <FormControl fullWidth size="small" error={Boolean(touched.state && errors.state)}>
                                        <Select name="state" value={values.state} displayEmpty
                                            onChange={(e) => {
                                                const stateName = e.target.value;
                                                setFieldValue("state", stateName);
                                                const sel = states.find((s) => s.name === stateName) || null;
                                                setSelectedState(sel);
                                                setFieldValue("city", "");
                                            }}
                                        >
                                            <MenuItem value="" disabled>Select State</MenuItem>
                                            {states.map((s) => (
                                                <MenuItem key={s.isoCode} value={s.name}>{s.name}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>{touched.state && errors.state}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* City */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>City <span style={{ color: "red" }}>*</span></span>
                                    <FormControl fullWidth size="small" error={Boolean(touched.city && errors.city)}>
                                        <Select name="city" value={values.city} displayEmpty onChange={handleChange}>
                                            <MenuItem value="" disabled>Select City</MenuItem>
                                            {cities.map((ct) => (
                                                <MenuItem key={ct.name} value={ct.name}>{ct.name}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText sx={{ color: "red" }}>{touched.city && errors.city}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                {/* Head Count */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Head Count</span>
                                    <FormControl fullWidth size="small">
                                        <Select name="headCount" value={values.headCount} displayEmpty onChange={handleChange}>
                                            <MenuItem value="" disabled>Select Head Count Range</MenuItem>
                                            {headCountOptions.map((range, index) => (
                                                <MenuItem key={index} value={range.value}>{range.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Revenue */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Revenue</span>
                                    <TextField name="revenue" type="number" fullWidth value={values.revenue} onChange={handleChange} size="small" />
                                </Grid>

                                {/* Primary Contact Email */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Primary Email <span style={{ color: "red" }}>*</span></span>
                                    <TextField name="primaryContactEmail" type="email" fullWidth value={values.primaryContactEmail} onChange={handleChange} onBlur={handleBlur}
                                        size="small" error={touched.primaryContactEmail && Boolean(errors.primaryContactEmail)}
                                        helperText={touched.primaryContactEmail && errors.primaryContactEmail} />
                                </Grid>

                                {/* Primary Contact Number */}
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                    <span style={{ fontSize: "16px" }}>Primary Phone <span style={{ color: "red" }}>*</span></span>
                                    <TextField name="primaryContactNumber" fullWidth value={values.primaryContactNumber} onChange={handleChange} onBlur={handleBlur}
                                        size="small" error={touched.primaryContactNumber && Boolean(errors.primaryContactNumber)}
                                        helperText={touched.primaryContactNumber && errors.primaryContactNumber} />
                                </Grid>

                                {/* CONTACT PERSONS SECTION - FIXED */}
                                <Grid item xl={12}>
                                    <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", mb: 1 }}
                                        onClick={() => setShowContactSection(!showContactSection)}>
                                        <Typography variant="h6" sx={{ flexGrow: 1, color: "#000000ffff" }}>
                                            Contact Persons *
                                        </Typography>
                                        <IconButton size="small">
                                            {showContactSection ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    </Box>
                                    {/* FIXED: Check if errors.contactPersons is string before rendering */}
                                    {typeof errors.contactPersons === 'string' && (
                                        <FormHelperText sx={{ color: "red", ml: 1, mb: 1 }}>
                                            {errors.contactPersons}
                                        </FormHelperText>
                                    )}

                                    <Collapse in={showContactSection}>
                                        <Divider sx={{ mb: 2 }} />
                                        <FieldArray name="contactPersons">
                                            {({ push, remove }) => (
                                                <div>
                                                    {values.contactPersons.map((contact, index) => (
                                                        <Box key={index} sx={{ mb: 2, p: 2 }}>
                                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                                                                <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#1976d2" }}>
                                                                    Contact Person {index + 1} <span style={{ color: "red" }}>*</span>
                                                                </Typography>
                                                                {values.contactPersons.length > 1 && (
                                                                    <IconButton size="small" onClick={() => remove(index)} color="error">
                                                                        <DeleteOutlineIcon />
                                                                    </IconButton>
                                                                )}
                                                            </Box>

                                                            <Grid container spacing={2}>
                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                                                    <span style={{ fontSize: "16px" }}>Name <span style={{ color: "red" }}>*</span></span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.name`}
                                                                        fullWidth
                                                                        value={contact.name}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(touched.contactPersons?.[index]?.name && errors.contactPersons?.[index]?.name)}
                                                                        helperText={touched.contactPersons?.[index]?.name && errors.contactPersons?.[index]?.name}
                                                                    />
                                                                </Grid>

                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                                                    <span style={{ fontSize: "16px" }}>Email <span style={{ color: "red" }}>*</span></span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.email`}
                                                                        type="email"
                                                                        fullWidth
                                                                        value={contact.email}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(touched.contactPersons?.[index]?.email && errors.contactPersons?.[index]?.email)}
                                                                        helperText={touched.contactPersons?.[index]?.email && errors.contactPersons?.[index]?.email}
                                                                    />
                                                                </Grid>

                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                                                    <span style={{ fontSize: "16px" }}>Phone <span style={{ color: "red" }}>*</span></span>
                                                                    <TextField
                                                                        name={`contactPersons.${index}.phone`}
                                                                        fullWidth
                                                                        value={contact.phone}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        size="small"
                                                                        error={Boolean(touched.contactPersons?.[index]?.phone && errors.contactPersons?.[index]?.phone)}
                                                                        helperText={touched.contactPersons?.[index]?.phone && errors.contactPersons?.[index]?.phone}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    ))}

                                                    <Button
                                                        type="button"
                                                        startIcon={<AddCircleOutlineIcon />}
                                                        onClick={() => push({ name: "", email: "", phone: "" })}
                                                        sx={{ mt: 1 }}
                                                    >
                                                        Add Another Contact Person
                                                    </Button>
                                                </div>
                                            )}
                                        </FieldArray>
                                    </Collapse>
                                </Grid>

                                {/* Submit */}
                                <Grid item xl={12}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }}>
                                        <Button variant="contained" type="submit" disabled={isSubmitting}
                                            style={{
                                                background: "#2777AA",
                                                fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                letterSpacing: "1"
                                            }}>
                                            Submit
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>

                            <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddCustomer;
